<template>
  <div v-loading="loading" class="admin">
    <h2>Editar Livro</h2>
    <el-form ref="form" :model="book" label-width="120px">
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item label="ISBN">
            <el-input v-model="book.isbn" @blur="searchBookByISBN"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8">
          <el-form-item label="Código">
            <el-input v-model="book.code"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item label="Titulo">
            <el-input v-model="book.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <section v-for="(item, index) in authors" :key="index">
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="Autor">
              <el-input v-model="authors[index]"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8">
            <el-button
              type="warn"
              v-on:click="removeFromArray('authors', index)"
              >Remover Autor</el-button
            >
          </el-col>
        </el-row>
      </section>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item>
            <el-button type="primary" v-on:click="addEmptyString('authors')"
              >Adicionar Autor</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item label="Editora">
            <el-input v-model="book.publisher"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8">
          <el-form-item label="Edição">
            <el-input v-model="book.edition"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item label="Cidade">
            <el-input v-model="book.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8">
          <el-form-item label="Ano">
            <el-date-picker
              type="year"
              placeholder="Escolha um ano"
              v-model="book.year"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item label="Capa">
            <file-upload />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="16" :offset="4">
          <el-form-item label="Descrição">
            <el-input
              autosize
              type="textarea"
              v-model="book.description"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="4">
          <el-form-item label="Categoria(s)">
            <el-select
              v-model="tagIds"
              filterable
              clearable
              remote
              v-bind:placeholder="Tag"
              :remote-method="searchTags"
              :loading="loading"
              multiple
            >
              <el-option
                v-for="tag in tags"
                :key="tag._id.$oid"
                :label="tag.value"
                :value="tag._id.$oid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="16" :offset="4">
          <el-form-item>
            <el-button type="primary" @click="goToBook()"
              >Ir para livro</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="16" :offset="4">
          <el-form-item class="form-buttons">
            <el-button type="warning" @click="updateBook">Editar</el-button>
            <el-button type="danger" @click="deleteBook">Deletar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getBook, updateBook, deleteBook } from "../../../services/book";
import { searchTags, getBookTags } from "../../../services/tags";
import { searchGoogleBooksByIsbn } from "../../../services/googleBooks";
import FileUpload from "../../../partials/FileUpload.vue";
export default {
  components: {
    "file-upload": FileUpload,
  },
  name: "Details",
  data() {
    return {
      book: {},
      authors: [],
      keywords: [],
      tagIds: [],
      tags: [],
      startYear: null,
    };
  },
  methods: {
    searchTags(query) {
      if (query) {
        var params = {};
        params.value = query;
        this.loading = true;
        searchTags(params).then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.tags = response.data;
          }
        });
        this.loading = false;
      }
    },
    goToBook() {
      this.$router.push(`/books/${this.$route.params.id}`);
    },
    async searchBookByISBN() {
      if (this.book.isbn) {
        this.loading = true;
        const response = await searchGoogleBooksByIsbn(this.book.isbn);
        this.loading = false;
        if (response.status == 200 && response.data.totalItems > 0) {
          const shouldFillData = await this.$confirm(
            "Encontrei algumas informações sobre esse livro, posso tentar preencher o que você nao preencheu ainda?",
            "Olá",
            {
              confirmButtonText: "Confirmar",
              cancelButtonText: "Cancelar",
              type: "warning",
            }
          );
          if (shouldFillData) {
            this.fillBookWithGoogleData(response.data.items[0]);
          }
        }
      }
    },
    fillBookWithGoogleData(googleBook) {
      if (googleBook.volumeInfo) {
        if (!this.book.title) {
          this.book.title = googleBook.volumeInfo.title;
        }
        if (
          this.authors.length == 0 ||
          (this.authors.length == 1 && this.authors[0] == "")
        ) {
          this.authors = googleBook.volumeInfo.authors;
        }
        if (!this.book.publisher) {
          this.book.publisher = googleBook.volumeInfo.publisher;
        }
        if (!this.book.description) {
          this.book.description = googleBook.volumeInfo.description;
        }
        if (!this.book.cover) {
          this.book.cover = googleBook.volumeInfo.imageLinks.thumbnail;
        }
      }
    },
    removeFromArray(name, index) {
      this[name].splice(index, 1);
    },
    addEmptyString(name) {
      this[name].push("");
    },
    async updateBook() {
      console.info(this.book);
      if (this.book.year != null && this.book.year != this.startYear) {
        this.book.year = String(this.book.year.getFullYear());
      }
      console.info("hello world");
      if (this.authors["length"] == "") {
        this.authors.pop();
      }
      this.book.authors = this.authors;
      this.book.tag_ids = this.tagIds;
      const response = await updateBook(this.$route.params.id, this.book);
      if (response.status === 204) {
        this.$message.success("Livro atualizado com sucesso!");
        this.$router.push(`/admin/books`);
      }
    },
    async getBook(id) {
      const response = await getBook(id);
      this.book = response.data;
      this.startYear = this.book.year;
      const bookTagsResponse = await getBookTags(id);
      this.tags = bookTagsResponse.data;
      this.tagIds = this.book.tag_ids ? this.book.tag_ids : [];
      if (this.book.authors) {
        this.authors = this.book.authors;
      }
    },
    async deleteBook() {
      const shouldDelete = await this.$confirm(
        "Essa é uma operação definitiva. Tem certeza que deseja continuar?",
        "Atenção",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      );
      if (shouldDelete) {
        const response = await deleteBook(this.book._id.$oid);
        if (response.status === 204) {
          this.$message.success("Livro deletado com sucesso!");
          this.$router.push(`/admin/books`);
        }
      }
    },
  },

  created() {
    this.getBook(this.$route.params.id).then(() => {
      this.emitter.emit("image", this.book.cover);
    });
  },

  mounted() {
    this.emitter.on("image", (coverUrl) => {
      this.book.cover = coverUrl;
    });
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

a {
  color: #42b983;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

.admin {
  margin: 30px;
}

.form-buttons {
  float: right;
}
</style>
